export default __webpack_public_path__ + "static/media/logo.5b641134.svg";